import type { SettingsTabConfig } from "@/features/feature.types";
import { permissionId } from "@/features/shared/featureFactories";

// Single source of truth for this feature's permission identity. Sidebar Branding is reached
// from Administration → Settings, so it's modeled as an Administration feature
// ("BrandingSidebar"), not a peer top-level module — must match permissions.json's
// Administration.BrandingSidebar block exactly.
const PERMISSION_MODULE = "Administration";
const PERMISSION_FEATURE = "BrandingSidebar";

export const SIDEBAR_BRANDING_PERMISSIONS = {
  read: permissionId(PERMISSION_MODULE, PERMISSION_FEATURE, "read"),
  manage: permissionId(PERMISSION_MODULE, PERMISSION_FEATURE, "manage"),
};

// Branding owns this contribution — Administration never references SidebarBrandingTab.tsx or
// this permission string directly (see src/features/settingsTabRegistry.ts).
export const SIDEBAR_BRANDING_SETTINGS_TAB: SettingsTabConfig = {
  id: "sidebar-branding",
  label: "Sidebar Branding",
  permission: SIDEBAR_BRANDING_PERMISSIONS.read,
  loader: () => import("./SidebarBrandingTab"),
};
